// src/api/constants/notifications/notificationLevelIcons.ts

import {
  CheckCircle2,
  AlertTriangle,
  Info,
  XCircle,
  Shield,
  DollarSign,
  Package,
  ShoppingCart,
  ClipboardList,
  RefreshCw,
  Database,
  Wrench,
  Bell,
  User,
  MessageSquare,
  GraduationCap,
  Megaphone,
  Cloud,
  Printer,
  Cpu,
  Activity,
  HelpCircle,
  type LucideIcon,
} from "lucide-react";

/**
 * 🔔 NotificationLevel
 *
 * Debe mantenerse 1:1 con backend:
 * com.base.starter.codenovapos.enums.NotificationLevel
 *
 * Referencia backend:
 * NotificationLevel.java
 * NotificationLevelResolver.java
 */
export const NOTIFICATION_LEVEL_ICONS: Record<
  string,
  LucideIcon
> = {
  // =========================================================
  // 🟦 NIVELES BASE
  // =========================================================

  INFO: Info,
  SUCCESS: CheckCircle2,
  WARNING: AlertTriangle,
  ERROR: XCircle,
  CRITICAL: XCircle,

  // =========================================================
  // 🟨 FUNCIONALES
  // =========================================================

  AUDIT: ClipboardList,
  SECURITY: Shield,
  FINANCIAL: DollarSign,
  STOCK: Package,
  SALE: ShoppingCart,
  PURCHASE: ClipboardList,
  INVENTORY: Package,

  // =========================================================
  // 🟩 INTEGRACIONES
  // =========================================================

  INTEGRATION: RefreshCw,
  SYNC: RefreshCw,
  API: Activity,
  NETWORK: Activity,

  // =========================================================
  // 🟪 SOPORTE / MANTENIMIENTO
  // =========================================================

  SUPPORT: HelpCircle,
  MAINTENANCE: Wrench,
  SYSTEM_UPDATE: Wrench,
  BACKUP: Database,
  PERFORMANCE: Activity,

  // =========================================================
  // ⚫ USUARIO / PERSONALIZACIÓN
  // =========================================================

  USER_ACTIVITY: User,
  USER_FEEDBACK: MessageSquare,
  ANNOUNCEMENT: Megaphone,
  TRAINING: GraduationCap,

  // =========================================================
  // 🟥 SISTEMA AVANZADO
  // =========================================================

  DATABASE: Database,
  SERVICE: Cpu,
  SCHEDULER: Bell,
  HARDWARE: Cpu,
  PRINTER: Printer,
  DEVICE: Cpu,
  CLOUD: Cloud,
  ALERT: Bell,
  UNKNOWN: HelpCircle,
};